import { AxiosInstance } from 'axios'
import React from 'react'

import { Dictionary } from '../utils/types'

export type AppConfig = {
  primaryLanguage: string
  availableLanguages: string[]
  axios: AxiosInstance
  icons: Dictionary<React.ComponentType<any>>
  images: Dictionary<any>
}

export const DefaultAppConfig: AppConfig = {
  availableLanguages: ['en', 'ind'],
  primaryLanguage: 'en',
  // @ts-ignore
  axios: {},
  icons: {},
  images: {}
}

export const AppConfigContext = React.createContext<AppConfig>(DefaultAppConfig)
